"use client";

import React from "react";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
const wp_query_params = {
  per_page: 6,
  status: "publish",
  order: "desc",
  orderby: "date"
};
const wp_query = new WP_Query(wp_query_params);
function ProductGridConsumer() {
  const {
    products,
    loading,
    error,
    refetch
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="12371" className="grid grid-cols-1 md:grid-cols-2 w-full bg-background">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="border-b border-accent/10 p-6 md:p-12 h-[600px] animate-pulse w-full">
            <div className="w-full h-[400px] bg-card/50 rounded-lg" />
            <div className="mt-8 h-6 w-2/3 bg-card/50 rounded" />
            <div className="mt-2 h-4 w-1/3 bg-card/50 rounded" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="py-20 text-center w-full bg-background">
        <p className="text-muted-foreground font-mono text-sm tracking-widest mb-4">SYSTEM_ERROR: UNABLE_TO_RETRIEVE_ASSETS</p>
        <button onClick={refetch} className="underline font-mono text-xs tracking-widest hover:text-primary uppercase">
          Reinitialize_Query
        </button>
      </div>;
  }
  if (products.length === 0) {
    return <div className="py-20 text-center text-muted-foreground font-mono text-sm tracking-widest w-full bg-background">
        NULL_RESULT: NO_ASSETS_FOUND.
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-2 w-full bg-background">
      {products.map((product, i) => {
      const isRightColumn = i % 2 !== 0;
      const isLastRowDesktop = i >= products.length - (products.length % 2 === 0 ? 2 : 1);
      const isLastItem = i === products.length - 1;
      return <div key={product.id} data-index={i} className={cn("group relative p-6 md:p-12 border-accent/10 w-full transition-colors duration-500 hover:bg-card/30", isLastItem ? "border-b-0" : "border-b", "md:border-b", isLastRowDesktop && "md:border-b-0", "md:odd:border-r md:odd:border-accent/10")}>
            <div className={cn("flex flex-col h-full w-full", isRightColumn && "md:mt-10")}>
              {}
              <Link to={product.link} className="block overflow-hidden aspect-[3/4] bg-muted w-full relative">
                {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110 grayscale group-hover:grayscale-0" loading="lazy" /> : <div className="h-full w-full bg-muted flex items-center justify-center text-muted-foreground font-mono text-xs tracking-tighter">
                    NO_VISUAL_DATA
                  </div>}
                <div className="absolute inset-0 pointer-events-none bg-[linear-gradient(rgba(18,16,16,0)_50%,rgba(0,0,0,0.1)_50%),linear-gradient(90deg,rgba(255,0,0,0.02),rgba(0,255,0,0.01),rgba(0,0,255,0.02))] bg-[length:100%_4px,3px_100%] opacity-20"></div>
              </Link>

              {}
              <div className="flex flex-col w-full">
                <Link to={product.link}>
                  <h3 className="font-sans text-3xl text-foreground pt-8 font-medium leading-none tracking-tighter uppercase">
                    {product.title}
                  </h3>
                </Link>

                <div className="mt-6 flex items-baseline justify-between font-mono text-[10px] tracking-[0.25em] text-accent w-full">
                  <span className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-accent animate-pulse" />
                    {product.price !== undefined ? `CAPACITY_${product.price.toFixed(0)}GH/S` : "SPEC_PENDING"}
                  </span>
                  
                  <div className="flex items-center">
                    <AddToCartButton productId={product.id} variant="link" text="DEPLOY_NODE" showQuantity={false} className="p-0 h-auto w-auto" buttonClassName="bg-transparent text-accent hover:text-foreground transition-colors hover:no-underline p-0 h-auto font-mono text-[10px] tracking-[0.25em] uppercase" />
                  </div>
                </div>
              </div>
            </div>
          </div>;
    })}
    </div>;
}
export default function ProductGrid() {
  return <section id="portfolio-highlights" className="bg-background text-foreground w-full border-y border-accent/10">
      <div className="w-full max-w-[1440px] mx-auto">
        <EcommerceProductsProvider wp_query={{
        per_page: 6,
        status: ["publish"],
        order: "desc",
        orderby: "date"
      }}>
          <ProductGridConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}